import type { NewPendingMessage } from "@/components/ai/chat/ChatInput";
import type { Message, PendingMessage } from "@/hooks/use-stream-conversation";
import { useState } from "react";

export const useOptimisticPendingMessages = () => {
    const [pendingMessages, setPendingMessages] = useState<PendingMessage[]>([]);

    const handleNewMessage = (message: NewPendingMessage, existingMessages: Message[]) => {
        if (!message.content) {
            // If content is undefined, it means the message with `id` failed to be sent
            // and should be retracted again.
            setPendingMessages((prev) => prev.filter((m) => m.id !== message.id));
            return;
        }

        // Filter out any pending messages that have already been retained in the conversation. This mostly
        // so that the pending messages don't grow indefinitely.
        const existingIds = existingMessages.map((m) => m.fragments.map((f) => f.id)).flat();
        const filtered = pendingMessages.filter((m) => existingIds.includes(m.id) === false);
        const msg = {
            id: message.id,
            content: message.content,
        } satisfies PendingMessage;
        setPendingMessages([...filtered, msg]);
    };

    return { pendingMessages, setPendingMessages, handleNewMessage };
};
